import { getElements, ifSelectorExist, getElement } from "./utils";

export const cf7Events = () => {

  // setup page id to the form

  let containerPostFields = getElements('input[name="post_id"]');
  
  if (ifSelectorExist(containerPostFields)) {
    console.log('cl before foreach')
    Array.from(containerPostFields).forEach(input => {
      console.log('cl inside foreach')
      input.value = wpAjax.page_id;
      console.log('input.value == ', input.value)
    })
  }

}